'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export default function DistributorSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const faqs: FAQItem[] = [
    {
      id: 'dist_1',
      question: 'How can I become a Bloom distributor?',
      answer: 'To become a Bloom distributor, you need to meet our basic requirements including having an established agro-vet business or retail location, storage facilities, and commitment to our quality standards. Fill out the distributor application form on our Contact page or call us at 0777 014 115 to start the application process.'
    },
    {
      id: 'dist_2',
      question: 'Is my territory available for distribution?',
      answer: 'We are actively expanding our distributor network across Uganda. Territory availability depends on current coverage in your area. Contact our partnership team to check if your desired territory is available. We prioritize areas with high poultry farming activity and limited access to quality feed concentrates.'
    },
    {
      id: 'dist_3',
      question: 'What are the investment requirements?',
      answer: 'Investment requirements vary based on territory size and expected order volumes. Initial investment typically covers your first stock order, storage setup, and marketing materials. We offer flexible payment terms for qualified distributors. Contact our sales team for detailed investment information specific to your location and business capacity.'
    },
    {
      id: 'dist_4',
      question: 'What support do you provide to distributors?',
      answer: 'We provide comprehensive support including product training, marketing materials, technical support for your customers, regular farm visits, promotional support, and dedicated account management. We also offer training on poultry nutrition to help you better serve farmers in your territory.'
    }
  ];

  const toggleFAQ = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-section-sm px-6 bg-secondary/5">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12">
          <h2 className="text-heading-3 text-foreground mb-4">Distributor Requirements</h2>
          <p className="text-muted-foreground">
            Information about becoming a Bloom distributor, territory availability, and support provided.
          </p>
        </div>

        <div className="space-y-4">
          {faqs?.map((faq) => (
            <div
              key={faq?.id}
              className="bg-white rounded-lg border border-border overflow-hidden transition-all hover:shadow-md"
            >
              <button
                onClick={() => toggleFAQ(faq?.id)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-secondary/5 transition-colors"
              >
                <span className="font-semibold text-foreground pr-4">{faq?.question}</span>
                <Icon
                  name={openId === faq?.id ? 'ChevronUpIcon' : 'ChevronDownIcon'}
                  size={20}
                  className="text-primary flex-shrink-0"
                />
              </button>
              {openId === faq?.id && (
                <div className="px-6 pb-5 text-muted-foreground leading-relaxed">
                  {faq?.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}